import { LegalLayout } from "@/components/LegalLayout";

export default function CookiePolicy() {
  return (
    <LegalLayout eyebrow="— Pravne informacije" title="Politika kolačića" lastUpdated="prosinac 2025.">
      <p>
        Ova Politika kolačića objašnjava kako i zašto stranica <em>lamaisonbyfp.com</em> koristi kolačiće
        (engl. <em>cookies</em>) i slične tehnologije, sukladno{" "}
        <strong>Zakonu o elektroničkim komunikacijama (NN 76/22)</strong> i odredbama ePrivacy direktive (2002/58/EZ).
      </p>

      <h2>1. Što su kolačići?</h2>
      <p>
        Kolačići su male tekstualne datoteke koje web-stranica pohranjuje u Vaš preglednik. Omogućuju da
        stranica zapamti informacije o Vašoj sesiji (npr. prijavu, postavke) i da radi ispravno.
      </p>

      <h2>2. Koje kolačiće koristimo?</h2>

      <h3>Nužni (esencijalni) kolačići</h3>
      <p>Ovi kolačići potrebni su za osnovno funkcioniranje stranice i ne mogu se onemogućiti.</p>
      <table>
        <thead>
          <tr><th>Naziv</th><th>Svrha</th><th>Trajanje</th></tr>
        </thead>
        <tbody>
          <tr>
            <td><code>access_token</code></td>
            <td>Prijava i sesija u administrativni dio stranice (samo za vlasnika).</td>
            <td>8 sati</td>
          </tr>
          <tr>
            <td><code>lm_cookie_consent</code></td>
            <td>Pamti Vaš izbor o suglasnosti za kolačiće.</td>
            <td>12 mjeseci</td>
          </tr>
        </tbody>
      </table>

      <h3>Analitički kolačići</h3>
      <p>Trenutno <strong>ne koristimo</strong> Google Analytics ni druge analitičke alate koji bi postavljali kolačiće u Vašem pregledniku.</p>

      <h3>Marketinški kolačići</h3>
      <p>Trenutno <strong>ne koristimo</strong> marketinške ni oglašivačke kolačiće.</p>

      <h3>Kolačići trećih strana (kad ih aktivirate)</h3>
      <p>
        Stranica sadrži ugrađenu Google Maps kartu (footer). Tek kad otvorite kartu, Google može postaviti
        svoje kolačiće. Pravila tih kolačića propisuje Google: <a href="https://policies.google.com/technologies/cookies" target="_blank" rel="noreferrer">policies.google.com/technologies/cookies</a>.
      </p>

      <h2>3. Kako upravljati kolačićima?</h2>
      <p>
        Većinu kolačića možete blokirati ili obrisati u postavkama Vašeg preglednika (Chrome, Safari, Firefox,
        Edge). Imajte na umu da onemogućavanje nužnih kolačića može narušiti rad pojedinih dijelova stranice
        (primjerice admin prijava više neće biti moguća).
      </p>
      <ul>
        <li>Chrome — <em>Postavke → Privatnost i sigurnost → Kolačići</em></li>
        <li>Safari — <em>Postavke → Privatnost</em></li>
        <li>Firefox — <em>Postavke → Privatnost i sigurnost</em></li>
        <li>Edge — <em>Postavke → Kolačići i dopuštenja</em></li>
      </ul>

      <h2>4. Vaša suglasnost</h2>
      <p>
        Pri prvom posjetu stranici prikazujemo Vam obavijest o kolačićima. Prihvaćanjem te obavijesti dajete
        suglasnost za postavljanje opcionalnih kolačića. Suglasnost možete povući u bilo kojem trenutku
        brisanjem kolačića u pregledniku.
      </p>

      <h2>5. Kontakt</h2>
      <p>
        Za pitanja vezana uz kolačiće možete nas kontaktirati na{" "}
        <a href="mailto:lamaisonbyfp@gmail.com">lamaisonbyfp@gmail.com</a>.
      </p>
    </LegalLayout>
  );
}
